import { DownloadButtons } from '@components/_SiteWide/UploadStatus/DownloadButtons'
import { onExport } from '@gravitate-js/excalibrr'
import { Menu } from 'antd'
import type React from 'react'

type DownloadButtonProps = {
  fileName: string
  gridAPIRef: React.MutableRefObject<any>
}

function hasColumnsToExclude(gridAPIRef) {
  return gridAPIRef.current?.getColumnDefs().filter((col) => col.excludeFromExport)
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ fileName, gridAPIRef }) => {
  // Tag your column with excludeFromExport if you need to always exclude it from export

  const handleMenuClick = (e) => {
    const columnsToExclude = hasColumnsToExclude(gridAPIRef)
    if (e.key === 'all' && columnsToExclude.length > 0) {
      const columnsToExport = gridAPIRef.current?.getColumnDefs().filter((col) => !col.excludeFromExport)
      return onExport(gridAPIRef, {
        fileName: `${fileName}.xlsx`,
        columnKeys: columnsToExport.map((col) => col.field),
      })
    }
    onExport(gridAPIRef, {
      fileName: `${fileName}.xlsx`,
      allColumns: e.key === 'all',
    })
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key='all'>Export All Columns (Default)</Menu.Item>
      <Menu.Item key='visible'>Export Only Visible Columns</Menu.Item>
    </Menu>
  )

  return (
    <DownloadButtons
      overrideOptions={[
        { title: 'Export All Columns (Default)', key: 'all' },
        { title: 'Export Only Visible Columns', key: 'visible_columns' },
      ]}
      onDownload={handleMenuClick}
      isLoading={false}
    />
  )
}
